import { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router'

import { BarsOutlined } from '@ant-design/icons'
import { Button, Drawer, Flex, Menu, theme } from 'antd'

import { headerItems } from './index'

const Burger = () => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { formatMessage } = useIntl()
  const { token } = theme.useToken()
  const [currentPathname, setCurrentPathname] = useState(pathname)

  const onClick = useCallback(
    (it: { key: string }) => {
      setOpen((prevState) => !prevState)
      navigate(it.key)
    },
    [navigate],
  )

  useEffect(() => {
    const elements = window.document.querySelectorAll<HTMLDivElement>('.blur')
    if (elements.length > 0) {
      if (open) {
        elements.forEach((it) => (it.style.filter = 'blur(5px)'))
      } else {
        elements.forEach((it) => (it.style.filter = 'unset'))
      }
    }
  }, [open])

  useEffect(() => {
    if (currentPathname !== pathname) {
      setOpen(false)
      setCurrentPathname(pathname)
    }
  }, [pathname, currentPathname])

  return (
    <Flex>
      <Button size={'large'} onClick={() => setOpen((prevState) => !prevState)} icon={<BarsOutlined />} />
      <Drawer
        open={open}
        styles={{ wrapper: { transition: 'none' }, content: { opacity: 0.8, background: token.Layout?.headerBg } }}
        onClose={() => setOpen((prevState) => !prevState)}
        placement={'right'}
        height={'100%'}
        width={'100%'}
      >
        <Menu
          selectedKeys={[pathname]}
          theme={'dark'}
          triggerSubMenuAction={'click'}
          mode={'vertical'}
          style={{ background: 'transparent', width: '100%' }}
          items={headerItems.map((it) => ({ ...it, label: formatMessage({ id: it.label }), onClick }))}
        />
      </Drawer>
    </Flex>
  )
}

export { Burger }
